import { LoaderDetailsType } from '../types/LoaderDetailsType';

export type LoaderState = {
    loaderDetails: LoaderDetailsType[];
};

export type LoaderAction = {
    type: 'add' | 'remove' | 'reset' | 'complete' | 'removeAllCompleted';
    loaderDetail?: LoaderDetailsType;
    endpoint?: string;
    additionalLoaderData?: any;
    requestId?: string;
};

export default (state: LoaderState, action: LoaderAction): LoaderState => {
    switch (action.type) {
        case 'add': {
            const _loaders = [...state.loaderDetails];
            _loaders.push({ ...action.loaderDetail, status: 'loading' });
            return {
                loaderDetails: [..._loaders],
            };
        }
        case 'complete': {
            return {
                loaderDetails: state.loaderDetails.map((l) =>
                    l.requestId === action.requestId ? { ...l, status: 'completed' } : l
                ),
            };
        }
        case 'remove': {
            if (action.requestId) {
                return {
                    loaderDetails: state.loaderDetails.filter((l) => l.requestId !== action.requestId),
                };
            }
            const _loaderDetails = action.additionalLoaderData
                ? [
                      ...[...state.loaderDetails].filter(
                          (l) => !(l.endpoint === action.endpoint && Object.is(l.additionalLoaderData, action.additionalLoaderData))
                      ),
                  ]
                : [...[...state.loaderDetails].filter((l) => l.endpoint !== action.endpoint)];

            return {
                loaderDetails: [..._loaderDetails],
            };
        }
        case 'removeAllCompleted': {
            return {
                loaderDetails: state.loaderDetails.filter((l) => l.status !== 'completed'),
            };
        }
        default:
            return state;
    }
};
